<template>
  <header :class="size">
    <div class="header-content">
      <div class="header-text">
        <span class="title">{{ title }}</span>
        <span
          v-if="size == 'splash'"
          class="subtitle"
        >{{ subtitle }}</span>
      </div>
      <div class="header-image">
        <img
          src="@/assets/images/alpaca.svg"
          alt="logo"
          class="logo"
        >
      </div>
    </div>
  </header>
</template>
<script>
import constants from '@/assets/constants.js';

export default {
  name: 'HeaderSection',
  props: {
    size: { type: String, default: 'small' }
  },
  data () {
    return {
      title: constants.TITLE,
      subtitle: constants.SUBTITLE
    };
  }
}
</script>
